<template>
  <v-container grid-list-md>
    <v-col align="start" justify="start">
      <v-row align="center">
        <v-col cols="6" sm="12" md="4">
          <div>
            <span class="headline font-weight-bold">List of all Ideas</span>
          </div>
          <span class="caption">You can Approve and Disapprove any of the ideas below.</span>
        </v-col>
        <!-- <v-divider></v-divider> -->
        <v-spacer></v-spacer>
        <v-col cols="6" sm="12" md="4" class="mt-5">
          <v-text-field
            label="Search for an Idea(s)"
            prepend-inner-icon="mdi-magnify"
            clearable
            rounded
            :append-icon="searchText ? 'mdi-send': 'mdi-magnify'"
            dense
            v-model="searchText"
            color="black"
            outlined
            @keyup.enter="searchIdea(searchText)"
            @click:append="searchIdea(searchText)"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-col>
    <!--  -->
    <div v-if="allIdeas.length > 0">
      <v-flex v-for="(item, i) in allIdeas" :key="i">
        <votingPanel :item="item"></votingPanel>
      </v-flex>
    </div>
    <!-- If ther is no list of ideas -->
    <v-container style="margin: 80px 0px" bg fill-height grid-list-md text-xs-center v-else>
      <v-row align="center" justify="center">
        <v-card class="elevation-10" style="border-radius: 5\7px">
          <v-container grid-list-md justify="center">
            <div>
              <span class="display-1">Oops! There is no Project Idea to display!</span>
            </div>
            <div>
              <span class="body-2">It looks like you need to submit new Idea(s).</span>
            </div>
          </v-container>
        </v-card>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import votingPanel from "@/components/VotingPanel";

export default {
  components: {
    votingPanel
  },

  data: () => ({
    date: null,
    searchText: ""
  }),
  methods: {
    ...mapActions("idea", ["getAllIdeas", "getAllMyIdeas", "vote"]),
    searchIdea(ideaText) {
      //
    }
  },
  created() {
    this.getAllIdeas();
  },
  computed: {
    ...mapGetters("idea", ["_getAllIdeas", "_getMyIdeas"]),
    ...mapState("idea", ["myIdeas", "allIdeas"]),
    ...mapState("auth", ["token"])
  }
};
</script>